import { Formik } from 'formik'
import { isArray, isEmpty } from 'lodash'
import { Fragment } from 'react'
import { useIntl, FormattedMessage, defineMessages } from 'react-intl'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'

import { Button } from 'components/v2/Button'
import { Column } from '@10xLabs/react-web/components/Column'
import { ErrorMessage } from 'components/v2/ErrorMessage'
import Heading from 'components/v2/Heading'
// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
import { PlusIcon } from '@10xLabs/react-web/components/Icons/Plus'
// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
import { TrashOIcon } from '@10xLabs/react-web/components/Icons/TrashO'
import { Input } from 'components/Input'
import { InputFile } from '@10xLabs/react-web/components/InputFile'
import { Row } from '@10xLabs/react-web/components/Row'
import { InputCurrency } from 'components/InputCurrency'
import { InputNumber } from 'components/InputNumber'
import FormLayout from 'features/App/components/FormLayout'
import { InputComboCategorySuggestion } from 'features/Snacks/components/InputComboCategorySuggestion'
import { InputComboSubcategorySuggestion } from 'features/Snacks/components/InputComboSubcategorySuggestion'
import { ItemAutocomplete, getItemLabel } from 'features/Snacks/components/ItemAutocomplete'
import { getUnprocessableErrors } from 'utils/error'
import { VALID_IMAGES } from 'utils/file'
import { sanitizePrice } from 'utils/math'
import { schema } from './schema'

const EMPTY_COMPONENT = {
  quantity: '',
  eligibleItems: [
    {
      id: '',
      name: ''
    }
  ]
}

const H6 = styled.h6<TSFixMe>`
  font-size: 14px;
  margin: 0;
  display: flex;
  align-items: center;
`

const TrashWrapper = styled.div<TSFixMe>`
  display: flex;
  cursor: pointer;
  margin-left: 20px;
`

const StyledTrashOIcon = styled(TrashOIcon)<TSFixMe>`
  fill: #1976d2;
  width: 16px;
  height: 18px;
`

const AddItemWrapper = styled.div<TSFixMe>`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #1976d2;
  font-size: 16px;

  svg {
    margin-right: 7px;
    fill: #1976d2;
    width: 18px;
    height: 18px;
  }
`

const messages = defineMessages({
  namePlaceholder: {
    id: 'spanish.dictionary.name',
    defaultMessage: 'Nombre'
  },
  categoryPlaceholder: {
    id: 'items.new.category.placeholder',
    defaultMessage: 'E.g.: Alimentos'
  },
  subcategoryPlaceholder: {
    id: 'items.new.subcategory.placeholder',
    defaultMessage: 'E.g.: Galletas'
  },
  productNamePlaceholder: {
    id: 'spanish.dictionary.product',
    defaultMessage: 'Producto'
  }
})

const NewComboForm = (props: TSFixMe): TSFixMe => {
  const {
    values,
    touched,
    errors,
    handleChange,
    setFieldValue,
    handleBlur,
    handleSubmit,
    error,
    loading,
    isEdit,
    companyId,
    s3Error
  } = props

  const intl = useIntl()

  const handleFileChange = (file: TSFixMe): TSFixMe => {
    setFieldValue('photo', file)
  }

  const addComponent = (): TSFixMe => {
    setFieldValue('components', [...values.components, EMPTY_COMPONENT])
  }

  return (
    <form autoComplete="off" onSubmit={handleSubmit}>
      <FormLayout.CardContent>
        <Row>
          <Column>
            <Heading.H5>
              <FormattedMessage id="spanish.combos.form.general.title" defaultMessage="General" />
            </Heading.H5>
          </Column>
        </Row>

        <Row>
          <Column width="50%">
            <Input
              id="name"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.name}
              placeholder={intl.formatMessage(messages.namePlaceholder)}
              touched={touched.name}
              errors={errors.name}
              label={<FormattedMessage id="spanish.dictionary.name" defaultMessage="Nombre" />}
            />
          </Column>
        </Row>

        <Row>
          <Column>
            <InputFile
              inputProps={{
                accept: VALID_IMAGES
              }}
              value={values.photo}
              label={
                <FormattedMessage
                  id="spanish.combos.new.photo"
                  defaultMessage="Foto <small>(Optional)</small>"
                  values={{
                    small: (msg): TSFixMe => <small>{msg}</small>
                  }}
                />
              }
              selectFileLabel={
                <FormattedMessage id="spanish.dictionary.selectFile" defaultMessage="Seleccionar archivo" />
              }
              onChange={handleFileChange}
            />
          </Column>
        </Row>

        <Row>
          <Column width="50%">
            <InputComboCategorySuggestion
              id="category"
              onChange={(category: TSFixMe): TSFixMe => setFieldValue('category', category)}
              onBlur={handleBlur}
              value={values.category}
              companyId={companyId}
              placeholder={intl.formatMessage(messages.categoryPlaceholder)}
              label={<FormattedMessage id="spanish.dictionary.category" defaultMessage="Categoría" />}
              touched={touched.category}
              errors={errors.category}
            />
          </Column>

          <Column width="50%">
            <InputComboSubcategorySuggestion
              id="subcategory"
              onChange={(subcategory: TSFixMe): TSFixMe => setFieldValue('subcategory', subcategory)}
              onBlur={handleBlur}
              value={values.subcategory}
              companyId={companyId}
              placeholder={intl.formatMessage(messages.subcategoryPlaceholder)}
              label={<FormattedMessage id="spanish.dictionary.subcategory" defaultMessage="Subcategoría" />}
              touched={touched.subcategory}
              errors={errors.subcategory}
            />
          </Column>
        </Row>

        <Row>
          <Column>
            <Heading.H5>
              <FormattedMessage id="spanish.combos.new.products" defaultMessage="Productos" />
            </Heading.H5>
          </Column>
        </Row>

        {values.components.map((component: TSFixMe, index: TSFixMe): TSFixMe => {
          const handleRemoveComponent = (): TSFixMe => {
            setFieldValue('components', [
              ...values.components.filter((_: TSFixMe, componentIndex: TSFixMe): TSFixMe => componentIndex !== index)
            ])
          }

          return (
            <Fragment key={index}>
              <Row>
                <Column>
                  <H6>
                    <FormattedMessage
                      id="spanish.combos.form.products.title"
                      defaultMessage="Producto #{productCount}"
                      values={{
                        productCount: index + 1
                      }}
                    />
                    {values.components.length > 1 && (
                      <TrashWrapper onClick={handleRemoveComponent}>
                        <StyledTrashOIcon />
                      </TrashWrapper>
                    )}
                  </H6>
                </Column>
              </Row>
              <Row>
                <Column width={`${100 / 3}%`}>
                  <ItemAutocomplete
                    placeholder={intl.formatMessage(messages.productNamePlaceholder)}
                    value={getItemLabel(values.components[index].eligibleItems[0], intl)}
                    label={<FormattedMessage id="spanish.dictionary.name" defaultMessage="Nombre" />}
                    onChange={(itemSelected: TSFixMe): TSFixMe => {
                      setFieldValue(`components[${index}].eligibleItems[0]`, itemSelected)
                    }}
                    filteredItemIds={values.components
                      .filter(({ eligibleItems }: TSFixMe): TSFixMe => eligibleItems[0].id)
                      .map(({ eligibleItems }: TSFixMe): TSFixMe => eligibleItems[0].id)}
                    companyId={companyId}
                    touched={
                      touched.components &&
                      touched.components[index] &&
                      touched.components[index].eligibleItems &&
                      touched.components[index].eligibleItems[0] &&
                      touched.components[index].eligibleItems[0].id
                    }
                    errors={
                      errors.components &&
                      errors.components[index] &&
                      errors.components[index].eligibleItems &&
                      errors.components[index].eligibleItems[0] &&
                      errors.components[index].eligibleItems[0].id
                    }
                    showOnlyActive
                    filterSims
                  />
                </Column>
                <Column width={`${100 / 3}%`}>
                  <InputNumber
                    id={`components[${index}].quantity`}
                    value={component.quantity}
                    placeholder="1"
                    onChange={(value: TSFixMe): TSFixMe => {
                      setFieldValue(`components[${index}].quantity`, value)
                    }}
                    onBlur={handleBlur}
                    touched={touched.components && touched.components[index] && touched.components[index].quantity}
                    errors={errors.components && errors.components[index] && errors.components[index].quantity}
                    maskOptions={{
                      suffix: '',
                      prefix: '',
                      allowDecimal: false
                    }}
                    label={<FormattedMessage id="spanish.dictionary.quantity" defaultMessage="Cantidad" />}
                  />
                </Column>
              </Row>
            </Fragment>
          )
        })}
        {touched.components && errors.components && !isArray(errors.components) && (
          <Row>
            <Column>
              <ErrorMessage>{errors.components}</ErrorMessage>
            </Column>
          </Row>
        )}
        <Row>
          <Column>
            <AddItemWrapper onClick={addComponent}>
              <PlusIcon />

              <FormattedMessage id="spanish.combos.form.addProduct" defaultMessage="Agregar producto" />
            </AddItemWrapper>
          </Column>
        </Row>
        <Row>
          <Column>
            <Heading.H5>
              <FormattedMessage id="spanish.dictionary.prices" defaultMessage="Precios" />
            </Heading.H5>
          </Column>
        </Row>
        <Row>
          <Column width="50%">
            <InputCurrency
              id="sellingPrice"
              label={<FormattedMessage id="spanish.dictionary.sellingPrice" defaultMessage="Precio de venta" />}
              value={values.sellingPrice}
              placeholder="$0.00"
              onChange={(value): TSFixMe => {
                setFieldValue('sellingPrice', value)
              }}
              onBlur={handleBlur}
              touched={touched.sellingPrice}
              errors={errors.sellingPrice}
              hideSuffix
            />
          </Column>
          <Column width="50%">
            <InputCurrency
              id="minSellingPrice"
              label={
                <FormattedMessage
                  id="spanish.combos.new.minSellingPrice"
                  defaultMessage="Precio minimo <small>(Optional)</small>"
                  values={{
                    small: (msg): TSFixMe => <small>{msg}</small>
                  }}
                />
              }
              value={values.minSellingPrice}
              placeholder="$0.00"
              onChange={(value): TSFixMe => {
                setFieldValue('minSellingPrice', value)
              }}
              onBlur={handleBlur}
              hideSuffix
            />
          </Column>
        </Row>
      </FormLayout.CardContent>
      <FormLayout.Split />
      <FormLayout.CardFooter>
        {!isEmpty(s3Error) && (
          <div>
            <ErrorMessage>{s3Error}</ErrorMessage>
          </div>
        )}
        {error && (
          <div>
            <ErrorMessage errors={getUnprocessableErrors(error)}>
              <FormattedMessage id="spanish.combos.form.error" defaultMessage="Hubo un error al agregar su combo" />
            </ErrorMessage>
          </div>
        )}
        <FormLayout.CardFooterActions>
          <Button as={NavLink} to="/snacks/combos" kind="cancel">
            <FormattedMessage id="spanish.dictionary.cancel" defaultMessage="Cancelar" />
          </Button>
          <Button type="submit" kind="primary" loading={loading}>
            {isEdit ? (
              <FormattedMessage id="spanish.dictionary.update" defaultMessage="Editar" />
            ) : (
              <FormattedMessage id="spanish.dictionary.add" defaultMessage="Agregar" />
            )}
          </Button>
        </FormLayout.CardFooterActions>
      </FormLayout.CardFooter>
    </form>
  )
}

export const NewCombo = ({ combo = {}, companyId, onSubmit, error, s3Error, loading, isEdit }: TSFixMe): TSFixMe => {
  const intl = useIntl()

  const initialItem = {
    name: combo.name || '',
    photo: combo.photoPath || '',
    category: combo.category || '',
    subcategory: combo.subcategory || '',
    sellingPrice: combo.sellingPrice ? sanitizePrice(combo.sellingPrice / 100) : '',
    minSellingPrice: combo.minSellingPrice ? sanitizePrice(combo.minSellingPrice / 100) : '',
    components: combo.components || [EMPTY_COMPONENT]
  }

  return (
    <Formik initialValues={initialItem} validationSchema={schema(intl)} onSubmit={onSubmit}>
      {(props): TSFixMe => {
        return (
          <NewComboForm
            {...props}
            companyId={companyId}
            isEdit={isEdit}
            error={error}
            s3Error={s3Error}
            loading={loading || props.isSubmitting}
          />
        )
      }}
    </Formik>
  )
}
